import { useState } from "react";

export default function useInvalidShake() {
  const [shakeClassName, setShakeClassName] = useState<"" | "animation-shake-horizontal">("");
  const handleInvalidShake = (valid: boolean) => {
    if (!valid) {
      setShakeClassName("animation-shake-horizontal");
      setTimeout(() => {
        setShakeClassName("");
      }, 600);
    }
  };
  return { shakeClassName, handleInvalidShake };
}
